import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import api, { apiError } from "@/lib/api";
import { Textarea } from "@/components/ui/textarea";

export default function PaymentActions({ data, onDone }) {
  const { user } = useAuth();
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const manager = ["store_manager", "owner"].includes(user?.role);
  const isDraft = data.status === "draft";
  const counts = ["submitted", "approved"].includes(data.status);
  if (!(isDraft && (manager || data.submitted_by === user?.id)) && !(counts && manager)) return null;
  const act = async (path) => {
    setBusy(true);
    try {
      await api.patch(`/payments/${data.id}/${path}`, { reason });
      toast.success(path === "reverse" ? "Payment reversed — balances restored" : path === "submit" ? "Payment recorded" : "Draft cancelled");
      setReason("");
      onDone();
    } catch (e) { toast.error(apiError(e, "Could not update payment")); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3 rounded-xl border border-navy/10 bg-white p-4" data-testid="payment-actions">
      {counts && <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Why is this payment being reversed? (at least 10 characters)" rows={2} data-testid="reverse-reason-input" />}
      <div className="flex gap-2">
        {isDraft && data.submitted_by === user?.id && <button type="button" disabled={busy} onClick={() => act("submit")} data-testid="submit-draft-payment-btn" className="flex-1 min-h-[44px] rounded-xl bg-gold text-navy font-semibold disabled:opacity-40">Record payment</button>}
        {isDraft && <button type="button" disabled={busy} onClick={() => act("cancel")} data-testid="cancel-draft-payment-btn" className="flex-1 min-h-[44px] rounded-xl border border-navy/15 text-navy disabled:opacity-40">Cancel draft</button>}
        {counts && <button type="button" disabled={busy || reason.trim().length < 10} onClick={() => act("reverse")} data-testid="reverse-payment-btn" className="flex-1 min-h-[44px] rounded-xl border border-red-300 text-red-700 disabled:opacity-40">Reverse payment</button>}
      </div>
    </div>
  );
}
